(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
	var mod = $('#menu-burger-menu, #menu-burger-menu-finska');

	if (mod.length) {
		// Dropdown toggler for mobile (added regardless of resolution and hidden with CSS)
		mod.find('> li.dropdown').each(function () {
			var menuItem = $(this);
			var toggler = $('<a role="button" class="dropdown-toggle-icon icon-plus icon--round icon--round--transparent"></a>').appendTo(menuItem);

			toggler.click(function (e) {
				e.preventDefault();

				menuItem.toggleClass('open');
				toggler.toggleClass('icon-plus icon-minus');
			});
		});

		// Open active menu items immediately
		mod.find('li.active, li.active-parent, li.active-ancestor').addClass('open').find('a.dropdown-toggle-icon').toggleClass('icon-plus icon-minus');

		// "Show more" togglers (specific to burger menu for now)
		mod.find('li.collapse').each(function () {
			var parent = $(this);
			var toggler = parent.find('li.collapse__toggle a');

			toggler.click(function (e) {
				e.preventDefault();

				parent.addClass('collapse--open');
				toggler.parent().hide();
			});
		});
	}
})();
